"use client";

import { VideoWorkflowStepName } from "@/app/api/[[...route]]/services/ai/ai-video-workflow/types";
import { useVideoWorkflow } from "../videoWorkflowProvider";
import ErrorState from "./errorState";
import { Progress } from "@/components/ui/progress";
import { VideoWorkflowStepProps } from "../videoWorkflowStep";
import { Sparkles } from "lucide-react";
import { t } from "@/lib/localization";

export default function ProgressState({
    texts,
    stepName,
}: {
    texts: VideoWorkflowStepProps["texts"];
    stepName: VideoWorkflowStepName;
}) {
    const { totalSteps, currentStep } = useVideoWorkflow();

    if (currentStep?.error) {
        return <ErrorState stepName={stepName} />;
    }

    return (
        <>
            <div className="mb-2 flex w-full justify-center items-center">
                <Sparkles className="fill-blue-600 text-blue-600 size-6" />
            </div>
            <h2 className="text-base font-semibold">
                {t(texts.title.keyName, undefined, undefined)}
            </h2>
            <p className="mt-0.5 text-sm text-muted-foreground">
                {t(texts.description.keyName, undefined, undefined)}
            </p>
            <div className="mt-4 flex w-full flex-col gap-1 items-center">
                <div className="flex w-full flex-row justify-between items-center gap-4">
                    {currentStep?.error ? (
                        <p className="text-xs font-semibold text-red-600">
                            {t(currentStep.error.keyName, undefined, undefined)}
                        </p>
                    ) : (
                        <>
                            <p className="text-xs text-muted-foreground">
                                {t("video-workflow-step.progress", undefined, {
                                    currentStep: (currentStep?.index || 0) + 1,
                                    totalSteps,
                                    stepName: currentStep
                                        ? t(
                                              `video-workflow.step-name.${currentStep.name}`
                                          )
                                        : "",
                                })}
                            </p>
                            <p className="text-xs text-muted-foreground">
                                {currentStep?.progress || 0}%
                            </p>
                        </>
                    )}
                </div>
                <Progress
                    indicatorClassName="bg-blue-600"
                    className="h-2"
                    value={
                        !currentStep || currentStep.error
                            ? 0
                            : currentStep.progress
                    }
                />
            </div>
        </>
    );
}
